import React, { useState, useEffect } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { 
  LockClosedIcon, 
  UserIcon, 
  EnvelopeIcon, 
  BuildingOfficeIcon,
  PhoneIcon
 } from "@heroicons/react/24/solid";

import { baseUrl } from "../baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { CalendarIcon } from "@heroicons/react/24/outline";
axios.defaults.baseURL = baseUrl;


const SignUp = () => {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(false);
  const [hide, setHide] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    center: "",
    name: "",
    email: "",
    password: "",
    phone: "",
    confirmPassword: "",
    ip: "0.0.0.0",
    role: "admin",
    license: "0000",
    user_id: "0000",
    user_limit: "0",
    expire_date: null,
    return_ip:"0.0.0.0",
    multicast_ip:"0.0.0.0"
  });

  useEffect(()=>{
    const relay_server_token = localStorage.getItem('relay_server_token');
    //console.log(relay_server_token);
    if(relay_server_token)
    {
      navigate("/dashboard");
    }
  },[]);

  useEffect(()=>{checkAdmin()}, []);

  
  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const fetch_signup = async () => {    
    setLoading(true);
    try{
          const res = await axios.post('https://workspace.vsatx.in/api/signup-details',{
            email: formData.email
          });
    
          if(res.data.success)
          {
            const d = res.data.data;

            setFormData((prev)=>({
              ...prev,
              name: d.name || "",
              email: d.email || "",
              phone: d.mobile || "",
              user_limit: d.user_limit || "",
              center: d.organization || "",
              expire_date: d.expiry_date || "",
              multicast_ip: d.multicast_ip || "",
              return_ip: d.return_ip || ""
            }));

            setHide(true);
            
          }
        }
        
        catch(error)
        {
          //console.log(error);
            toast.error(error.message);
        }

        setLoading(false);
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords don't match!");
      return;
    }
    setLoading(true);
    //console.log("Sign up with:", formData);

    try {
      const response = await axios.post("admin/relay-register", {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        center: formData.center,
        role: formData.role,
        ip: formData.ip,
        phone: formData.phone,
        license: formData.license,
        user_id: formData.user_id,
        user_limit: formData.user_limit,
        expire_date: formData.expire_date,
        multicast_ip: formData.multicast_ip,
        return_ip: formData.return_ip
      });

      

      if (response.data.success) {
        toast.success("Admin registered successfully! Please Login");
        setFormData({ name: "", email: "", password: "", phone: "", confirmPassword: "", center: "", reg_code: "00", user_limit: "00" });
        setTimeout(()=>{
          navigate("/");
        },3000);
        

      } else {
        toast.error(response.data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Registration Error:", error);
      toast.error(error.message);
    }
    setLoading(false);
  };

  const checkAdmin = async (e) => {
      try {
      const response = await axios.get("admin/check-admin-relay");
      //console.log(response);

      if (response.data.success) 
      {
        setAdmin(true);
      }

    } catch (error) {
      setAdmin(false);
    }
  }
  
  if (admin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Create Your Account
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* First Name Field */}

          
          {/* Email Field */}
          <div className="relative">
            <EnvelopeIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              type="email"
              name="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>

          <div className="relative">
            
            <button
              type="button"
              onClick={fetch_signup}
              disabled={loading}
              className="py-2 border border-gray-300 px-6 bg-indigo-600 text-white rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            >{loading ? 'Wait...': 'Fetch Admin'}</button>
          </div>
          {
            hide ? <div className={hide ? "space-y-4" : "hidden space-y-4"}>
          
          <div className="relative">
            <BuildingOfficeIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              readOnly
              type="text"
              name="center"
              placeholder="Organization Name"
              value={formData.center}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>

          {/* Last Name Field */}
          <div className="relative">
            <UserIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              readOnly
              type="text"
              name="name"
              placeholder="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>

          
          <div className="relative">
            <PhoneIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              readOnly
              type="number"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>

          
          {/* Password Field */}
          <div className="relative">
            <LockClosedIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
              minLength="6"
            />
          </div>

          {/* Confirm Password Field */}
          <div className="relative">
            <LockClosedIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>

          {/* user Limit Field */}
           <div className="relative">
            <UserIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
            <input
              type="number"
              name="user_limit"
              placeholder="User Limit"
              readOnly
              value={formData.user_limit}
              onChange={handleChange}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              required
            />
          </div>

          
          <div>
            
            <div className="relative">
              
              <CalendarIcon className="w-5 h-5 text-gray-400 absolute left-3 top-3" />
              <input
                readOnly
                type="date"
                name="expire_date"
                placeholder="Expire Date"
                value={formData.expire_date}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                required
              />
            </div>
          </div> 
          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 px-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-xl shadow-md transition"
          >
            {loading ? "Wait..." : "Create Account"}
          </button>
            </div> : ''
          }
        </form>
         <ToastContainer position="top-right" autoClose={3000} />
        <p className="text-sm text-gray-500 mt-6 text-center">
          Already have an account?{" "}
          <Link to="/" className="text-indigo-600 hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}

export default SignUp;